import { money, pct } from "@/lib/api";

export default function Ticker({ stocks = [], properties = [] }) {
  const items = [
    ...stocks.map((s) => ({ key: s.id, label: s.ticker, value: money(s.price), delta: s.change_pct, kind: "stock" })),
    ...properties.map((p) => ({ key: p.id, label: p.title, value: `${p.rental_yield}% yield`, kind: "property" })),
  ];
  if (!items.length) return null;
  const loop = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-slate-800 bg-surface/60 py-4" data-testid="asset-ticker">
      <div className="marquee-track flex gap-12">
        {loop.map((it, i) => (
          <div key={`${it.key}-${i}`} className="flex items-center gap-3 whitespace-nowrap font-mono text-sm tracking-tight">
            <span className={`h-1.5 w-1.5 rounded-full ${it.kind === "stock" ? "bg-emerald-500" : "bg-amber-600"}`} />
            <span className="text-slate-200">{it.label}</span>
            <span className="text-slate-400">{it.value}</span>
            {it.kind === "stock" && (
              <span className={it.delta >= 0 ? "text-emerald-400" : "text-red-400"}>{pct(it.delta)}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
